import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-full flex flex-col justify-end" }
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M64 96c0-53 43-96 96-96s96 43 96 96V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64s-64 28.7-64 64V384c0 53 43 96 96 96s96-43 96-96V144c0-8.8 7.2-16 16-16s16 7.2 16 16V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V96z",
    style: {"fill":"var(--agent-bubble-text-color)"}
  })
], -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M64 96c0-53 43-96 96-96s96 43 96 96V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64s-64 28.7-64 64V384c0 53 43 96 96 96s96-43 96-96V144c0-8.8 7.2-16 16-16s16 7.2 16 16V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V96z",
    style: {"fill":"var(--contact-bubble-text-color)"}
  })
], -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "text-xs flex flex-col space-y-2 text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Henter samtale...", -1)

import {
  GAppEventType,
  GConnectedServiceChatEntityConversationStartModeItem,
  GConversationTimelineDataFragment,
} from "@/generated/graphql";
import { inject, nextTick, onMounted, ref, toRefs, watch } from "vue";
import ChatBubbleBot from "@/features/chat-list/ChatBubbleBot.vue";
import ChatBubbleAgent from "@/features/chat-list/ChatBubbleAgent.vue";
import ChatBubbleContact from "@/features/chat-list/ChatBubbleContact.vue";
import ChatBubbleProcessing from "@/features/chat-list/ChatBubbleProcessing.vue";
import conversationMessagesPersistence, {
  ChatListMessage,
  ChatMessageItem,
} from "@/utils/conversationMessagesPersistence";
import { useGraphqlSdk } from "@/graphql/graphql-client";
import ChatBubbleEvent from "@/features/chat-list/ChatBubbleEvent.vue";
import { useEmitterOn } from "@/composables/useEmitterOn";
import { containsHtmlTags, isScrolledNearBottom, scrollToBottomInstant, scrollToBottomSmooth } from "@/utils/dom-utils";
import { useContactPersistence } from "@/utils/contactPersistence";
import { getConversationTimelineContent } from "@/utils/conversationTimelineDataHelper";
import emitter from "@/utils/mitt";
import SpinnerAnimation from "../shared/SpinnerAnimation.vue";
import { settingsInjectionKey, tenantInjectionKey } from "@/keys";
import { demoModeInjectionKey } from "../../keys";
import { resolveDisplayName, resolveNameInitials } from "@/utils/display-name-helper";
import { getDemoMessages } from "@/utils/demo";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatTimeline',
  props: {
  conversation: {
    type: String,
    required: true,
  },
},
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const props = __props;

console.log(props.conversation);

const { conversation: origConversation } = toRefs(props);
const tenant = inject(tenantInjectionKey);
const contactPersistence = useContactPersistence(tenant);
const messages = ref<ChatListMessage[]>([]);
const container = ref<HTMLDivElement>();
const conversationRef = ref();
conversationRef.value = origConversation?.value;
const loaded = ref(false);
const botAssistant = ref(false);
const noAgentsAvailable = ref(false);
const settings = inject(settingsInjectionKey);
const demoMode = inject(demoModeInjectionKey);

getMessages();
watch(origConversation, () => {
  conversationRef.value = origConversation?.value;
  getMessages();
});

useEmitterOn("messages-updated", async updatedConversation => {
  const isScrolledToBottom = isScrolledNearBottom(container.value);

  if (conversationRef.value === updatedConversation) {
    messages.value = conversationMessagesPersistence.getState(updatedConversation) ?? [];
    await nextTick();

    if (isScrolledToBottom) {
      scrollToBottomSmooth(container.value);
    }
  }
});

useEmitterOn("contact-message-sent", msg => {
  if (!conversationRef.value) {
    conversationRef.value = msg.conversation;
  }

  if (msg.botAssistant) {
    botAssistant.value = true;
  }

  if (msg.noAgentAvailable) {
    noAgentsAvailable.value = true;
  }
});

useEmitterOn("bot-message-received", msg => {
  if (msg.conversation === conversationRef.value) {
    botAssistant.value = false;
  }
});

useEmitterOn("subscription-reconnected", async () => {
  await getMessages(true);
});

async function getMessages(force = false) {
  if (demoMode || !tenant) {
    messages.value = getDemoMessages();
    loaded.value = true;
    return;
  }

  const contact = contactPersistence.getState();

  if (conversationRef?.value && contact) {
    messages.value = conversationMessagesPersistence.getState(conversationRef.value) ?? [];

    if (messages.value.length === 0 || force) {
      useGraphqlSdk()
        .GetConversationMessages({
          tenant: tenant,
          conversation: conversationRef.value,
          contact: contact,
          take: 50,
          includeAgent:
            settings!.value.conversationSettings.showAgentName || settings!.value.conversationSettings.showAgentAvatar,
        })
        .then(async res => {
          let counter = 0;
          messages.value = res.conversationMessagesById.map<ChatListMessage>(i => {
            counter++;
            const message: ChatListMessage = {
              id: counter.toString(),
              content: getConversationTimelineContent(i.data),
              type: getMessageType(i.data),
              isProcessing: false,
              agentName:
                i.data.__typename === "ConversationAgentMessage"
                  ? resolveDisplayName(
                      i.data.agent?.firstName,
                      i.data.agent?.lastName,
                      settings!.value.conversationSettings.agentNameVariation
                    )
                  : null,
              agentInitials:
                i.data.__typename === "ConversationAgentMessage"
                  ? resolveNameInitials(i.data.agent?.firstName, i.data.agent?.lastName)
                  : null,
              attachments:
                i.data.__typename === "ConversationContactMessage" || i.data.__typename === "ConversationAgentMessage"
                  ? i.data.attachments.map(f => {
                      return {
                        filename: f.filename,
                        size: f.size,
                        previewUrl: f.previewUrl,
                        downloadUrl: f.downloadUrl,
                      };
                    })
                  : [],
            };

            return message;
          });

          conversationMessagesPersistence.saveState(conversationRef.value, messages.value);
          await nextTick();
          loaded.value = true;
          emitter.emit("messages-updated", conversationRef.value);
        });
    } else {
      await nextTick();
      loaded.value = true;
    }
  } else if (
    settings!.value.behaviour.conversationStartMode ===
    GConnectedServiceChatEntityConversationStartModeItem.StartOnFirstContactMessage
  ) {
    loaded.value = true;
  }
}

function getMessageType(data: GConversationTimelineDataFragment): ChatMessageItem {
  switch (data.__typename) {
    case "ConversationAgentMessage":
      return ChatMessageItem.Agent;

    case "ConversationBotMessage":
      return ChatMessageItem.Bot;

    case "ConversationContactMessage":
      return ChatMessageItem.Contact;

    case "ConversationEvent":
      switch (data.eventType) {
        case GAppEventType.ConversationTransferred:
          return ChatMessageItem.TransferredEvent;

        case GAppEventType.ConversationChatEnded:
          return ChatMessageItem.ChatEndedEvent;
      }
  }

  throw new Error(`Unknown message type: ${data.__typename}`);
}

function showAgentMessageName(index: number) {
  if (index === 0) {
    return true;
  }

  if (messages.value[index - 1].type != ChatMessageItem.Agent) {
    return true;
  }

  // const previousTimelineData = messages.value[index - 1];
  // const currentTimelineData = messages.value[index];
  return false;
  // return previousTimelineData.agent?.id != currentTimelineData.agent?.id;
}

onMounted(async () => {
  await nextTick();
  scrollToBottomInstant(container.value);
});

watch(loaded, async () => {
  await nextTick();

  setTimeout(() => {
    scrollToBottomInstant(container.value);
  }, 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "flex-1 overflow-y-auto py-4 px-4 bg-gradient timeline"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (loaded.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(settings)?.text?.startMessage)
                ? (_openBlock(), _createBlock(ChatBubbleAgent, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(settings)?.text?.startMessage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (conversationRef.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: message.id
                      }, [
                        (message.isProcessing)
                          ? (_openBlock(), _createBlock(ChatBubbleProcessing, { key: 0 }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (message.type === _unref(ChatMessageItem).Bot)
                                ? (_openBlock(), _createBlock(ChatBubbleBot, {
                                    key: 0,
                                    "is-text": !_unref(containsHtmlTags)(message.content)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        innerHTML: message.content
                                      }, null, 8, _hoisted_3)
                                    ]),
                                    _: 2
                                  }, 1032, ["is-text"]))
                                : _createCommentVNode("", true),
                              (message.type === _unref(ChatMessageItem).Agent)
                                ? (_openBlock(), _createBlock(ChatBubbleAgent, {
                                    key: 1,
                                    "show-name": _unref(settings)?.conversationSettings.showAgentName && showAgentMessageName(index),
                                    "show-avatar": _unref(settings)?.conversationSettings.showAgentAvatar
                                  }, {
                                    name: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(message.agentName), 1)
                                    ]),
                                    initials: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(message.agentInitials), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        innerHTML: message.content
                                      }, null, 8, _hoisted_4),
                                      (message.attachments.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, (attachment, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `${attachment.filename}-${index}`,
                                                class: "flex flex-row items-center space-x-2"
                                              }, [
                                                _hoisted_6,
                                                _createElementVNode("a", {
                                                  href: attachment.downloadUrl,
                                                  class: "underline pb-1"
                                                }, _toDisplayString(attachment.filename), 9, _hoisted_7)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["show-name", "show-avatar"]))
                                : _createCommentVNode("", true),
                              (message.type === _unref(ChatMessageItem).Contact)
                                ? (_openBlock(), _createBlock(ChatBubbleContact, { key: 2 }, {
                                    default: _withCtx(() => [
                                      (message.attachments.length)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(message.attachments, (attachment, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `${attachment.filename}-${index}`,
                                              class: "flex flex-row items-center space-x-2"
                                            }, [
                                              _hoisted_8,
                                              _createElementVNode("a", {
                                                href: attachment.downloadUrl,
                                                class: "underline pb-1"
                                              }, _toDisplayString(attachment.filename), 9, _hoisted_9)
                                            ]))
                                          }), 128))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            innerHTML: message.content
                                          }, null, 8, _hoisted_10))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (message.type === _unref(ChatMessageItem).TransferredEvent)
                                ? (_openBlock(), _createBlock(ChatBubbleEvent, { key: 3 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Vi kommer tilbake til deg på " + _toDisplayString(message.content) + " så snart som mulig. ", 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (message.type === _unref(ChatMessageItem).ChatEndedEvent)
                                ? (_openBlock(), _createBlock(ChatBubbleContact, { key: 4 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Samtalen ble avsuttet. ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ], 64))
                    }), 128)),
                    (botAssistant.value)
                      ? (_openBlock(), _createBlock(ChatBubbleProcessing, { key: 0 }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(SpinnerAnimation, { class: "mx-auto" }),
              _hoisted_12
            ]))
      ])
    ])
  ], 512))
}
}

})